/* eslint-disable no-unused-vars, jsx-a11y/alt-text, react-hooks/exhaustive-deps */
// Loading Skeleton Components
// src/components/LoadingSkeleton.jsx

import React from 'react';

// Card Skeleton
export const CardSkeleton = ({ count = 1 }) => {
    return (
        <>
            {[...Array(count)].map((_, i) => (
                <div key={i} className="animate-pulse bg-white rounded-xl p-6 shadow-md">
                    <div className="h-48 bg-gray-200 rounded-lg mb-4"></div>
                    <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                </div>
            ))}
        </>
    );
};

// Table Skeleton
export const TableSkeleton = ({ rows = 5, columns = 4 }) => {
    return (
        <div className="animate-pulse">
            <table className="w-full">
                <thead>
                    <tr>
                        {[...Array(columns)].map((_, i) => (
                            <th key={i} className="p-4">
                                <div className="h-4 bg-gray-200 rounded"></div>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {[...Array(rows)].map((_, rowIndex) => (
                        <tr key={rowIndex}>
                            {[...Array(columns)].map((_, colIndex) => (
                                <td key={colIndex} className="p-4">
                                    <div className="h-4 bg-gray-100 rounded"></div>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

// Product Card Skeleton
export const ProductCardSkeleton = ({ count = 6 }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(count)].map((_, i) => (
                <div
                    key={i}
                    className="animate-pulse bg-white rounded-xl overflow-hidden shadow-md"
                >
                    <div className="h-48 bg-gray-200"></div>
                    <div className="p-4">
                        <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
                        <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
                        <div className="h-4 bg-gray-200 rounded w-2/3 mb-4"></div>
                        <div className="flex justify-between items-center">
                            <div className="h-8 bg-gray-200 rounded w-20"></div>
                            <div className="h-10 bg-gray-200 rounded w-24"></div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

// Dashboard Stats Skeleton
export const DashboardStatsSkeleton = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[...Array(4)].map((_, i) => (
                <div key={i} className="animate-pulse bg-white rounded-xl p-6 shadow-md">
                    <div className="flex items-center justify-between mb-4">
                        <div className="h-12 w-12 bg-gray-200 rounded-full"></div>
                        <div className="h-6 bg-gray-200 rounded w-16"></div>
                    </div>
                    <div className="h-8 bg-gray-200 rounded w-24 mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-32"></div>
                </div>
            ))}
        </div>
    );
};

// Chart Skeleton
export const ChartSkeleton = () => {
    return (
        <div className="animate-pulse bg-white rounded-xl p-6 shadow-md">
            <div className="h-6 bg-gray-200 rounded w-48 mb-6"></div>
            <div className="h-64 bg-gray-100 rounded flex items-end justify-around p-4">
                {[...Array(7)].map((_, i) => (
                    <div
                        key={i}
                        className="bg-gray-200 rounded-t w-12"
                        style={{ height: `${Math.random() * 100 + 50}px` }}
                    ></div>
                ))}
            </div>
        </div>
    );
};

// List Skeleton
export const ListSkeleton = ({ items = 5 }) => {
    return (
        <div className="space-y-4">
            {[...Array(items)].map((_, i) => (
                <div
                    key={i}
                    className="animate-pulse bg-white rounded-lg p-4 shadow-sm flex items-center gap-4"
                >
                    <div className="h-16 w-16 bg-gray-200 rounded-lg"></div>
                    <div className="flex-1">
                        <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                        <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                    </div>
                    <div className="h-8 w-20 bg-gray-200 rounded"></div>
                </div>
            ))}
        </div>
    );
};

// Form Skeleton
export const FormSkeleton = () => {
    return (
        <div className="animate-pulse bg-white rounded-xl p-6 shadow-md space-y-6">
            <div className="h-8 bg-gray-200 rounded w-48 mb-6"></div>

            {[...Array(4)].map((_, i) => (
                <div key={i}>
                    <div className="h-4 bg-gray-200 rounded w-24 mb-2"></div>
                    <div className="h-10 bg-gray-100 rounded w-full"></div>
                </div>
            ))}

            <div className="flex gap-4 pt-4">
                <div className="h-10 bg-gray-200 rounded w-24"></div>
                <div className="h-10 bg-gray-200 rounded w-24"></div>
            </div>
        </div>
    );
};

// Page Skeleton (Full Page)
export const PageSkeleton = () => {
    return (
        <div className="p-6 space-y-6">
            {/* Header */}
            <div className="animate-pulse flex justify-between items-center">
                <div className="h-10 bg-gray-200 rounded w-48"></div>
                <div className="h-10 bg-gray-200 rounded w-32"></div>
            </div>

            {/* Stats */}
            <DashboardStatsSkeleton />

            {/* Chart */}
            <ChartSkeleton />

            {/* Table */}
            <div className="bg-white rounded-xl p-6 shadow-md">
                <TableSkeleton rows={5} columns={5} />
            </div>
        </div>
    );
};

// Spinner (Simple Loading)
export const Spinner = ({ size = 'md', className = '' }) => {
    const sizes = {
        sm: 'h-4 w-4',
        md: 'h-8 w-8',
        lg: 'h-12 w-12',
        xl: 'h-16 w-16'
    };

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <div
                className={`${sizes[size]} border-4 border-gray-200 border-t-emerald-600 rounded-full animate-spin`}
            ></div>
        </div>
    );
};

// Loading Overlay
export const LoadingOverlay = ({ message = 'جاري التحميل...' }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-8 shadow-2xl flex flex-col items-center gap-4">
                <Spinner size="xl" />
                <p className="text-lg font-bold text-gray-800">{message}</p>
            </div>
        </div>
    );
};

export default {
    CardSkeleton,
    TableSkeleton,
    ProductCardSkeleton,
    DashboardStatsSkeleton,
    ChartSkeleton,
    ListSkeleton,
    FormSkeleton,
    PageSkeleton,
    Spinner,
    LoadingOverlay
};
